/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { ordersContentForCircularCard } from "../../orders/utils/ordersContentForCircularCard";
import { Link, useLocation } from "react-router-dom";
import OrdersOverviewCircularBar from "../../../components/OrdersOverviewCircularBar";
import { useDispatch } from "react-redux";
import moment from "moment";
import axiosProtected from "../../../../../api/config/baseWithToken";
import { getOrderTabIndex } from "../../../../../redux/slices/storeSlice";
import { Grid } from "@mui/material";

export default function OrderStatistics({selectDate, setOrdersTotalCount, storeOwner}) {
    const dispatch = useDispatch()
    const location = useLocation().pathname;
    const productsLocation = location === "/customer/dashboard";
    const [loading, setLoading] = useState(false)

    const [ordersStatistics, setOrdersStatistics] = useState(null);
    const getOrdersStatistics = useCallback(async () => {
        try {
          setLoading(true);
          await new Promise((resolve) => setTimeout(resolve, 1000));
          const formattedDate = selectDate.toISOString();
          const { data } = await axiosProtected.get(
            `/store/orders-statistics?date=${moment(formattedDate).format(
              "YYYY-MM-DD"
            )}`
          );
          setOrdersStatistics(data?.result);
          setOrdersTotalCount(data?.result?.totalCount);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      }, [dispatch, selectDate, setOrdersTotalCount]);
    
      useEffect(() => {
        if(!storeOwner){

          getOrdersStatistics();
        }
      }, [getOrdersStatistics]);

    const { totals } = ordersStatistics || {};

    const {
      totalWaitingOrders,
      totalProcessingOrders,
      totalShippedOrders,
      totalFailedOrders,
    } = totals || {};

  return (
    <>
      {ordersContentForCircularCard(
        totalWaitingOrders,
        totalProcessingOrders,
        totalShippedOrders,
        totalFailedOrders
      ).map((content, index) => (
        <Grid
          item
          xs={3}
          key={content.id}
          onClick={() =>
            productsLocation && dispatch(getOrderTabIndex(index + 1))
          }
          // sx={{border:"1px solid gray"}}
        >
          <Link to={`/customer${content.link}`}>
            <OrdersOverviewCircularBar
              content={content}
              index={index}
              globalLoading={loading}
              // setValue={setValue}
              // value={value}
            />
          </Link>
        </Grid>
      ))}
    </>
  );
}
